// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"777df550","793":"04644179"}[chunkId] + ".chunk.js";
};